<template>
    <div class="new_supplierAdmin">
       
        <div class="u-max-width  supplierAdminbanner">
               <div class="supplier-bannnertext">
                  <div class="supplier-bannnertext1">ONEBO全品类供应链招商</div>
                  <div class="supplier-bannnertext2">10万+全球分销商，一键刊登你的产品至OZON、Tik Tok、Shopify、Shopee、Lazada等跨境电商平台，实现海外业绩增长</div>
                  <div class="supplier-bannnertext3">
                    <span  class="u-m-r-20"><i class="el-icon-check" style="color:#FC6B1D"></i>0入驻费用</span>  
                    <span  class="u-m-r-20"><i class="el-icon-check" style="color:#FC6B1D"></i>万亿级市场</span>
                      <span class="u-m-r-20"><i class="el-icon-check" style="color:#FC6B1D"></i>10万+全球分销商</span>
                      <span  class="u-m-r-20"><i class="el-icon-check" style="color:#FC6B1D"></i>多跨境分销平台</span>
                  </div>
                  <div class="supplier-bannnerbtn">
                       <!-- <div class="bannnerbtn">立即咨询</div> -->
                       <div class="bannnerbtn bannnerbtn2-size1" @click="geturl('/SupplierAdminform')">供应链入驻</div>
                       <div class="bannnerbtn2" @click="geturl('/serverAdmin3')">入驻咨询</div> 
                       <div class="bannnerbtn2 bannnerbtn2-size" ><a href="https://www.onebose.com/pc/home" class="bannnerbtn2-a" target="_blank" >前往ONEBO分销平台</a> </div>
                  </div>
               </div>
               <!-- <div class="supplier-bannnerfoot">
                    <div class="supplier-bannnerfootView  u-min-width u-flex u-row-between" style="height:100%">
                        <div class="bannnerfootItem">
                            <span style="color:#FD681C">100万+</span>
                            <span>SKU商品</span>
                        </div>
                        <div class="bannnerfootItem">
                            <span style="color:#FD681C">20+</span>
                            <span>商品类目</span>
                        </div>
                        <div class="bannnerfootItem">
                            <span style="color:#FD681C">10万+</span>
                            <span>全球分销商</span>
                        </div>
                         <div class="bannnerfootItem">
                            <span style="color:#FD681C">10+</span>
                            <span>跨境分销平台</span>
                        </div>
                    </div>
               </div> -->
        </div>
         <div class="u-max-width u-p-t-140 u-p-b-20 supplierAdminItem3">
            <div class="supplierAdminItem3Title">ONEBO一站式跨境分销介绍</div>
            <div class="supplierAdminItem3Title2 u-m-t-20 u-m-b-50">简单做跨境 一产品卖全球</div>
            <div class="u-min-width">
                <video class="videoView"  src="../../../assets/images/newImg/index.mp4" controls> </video>  
            </div>
         </div>
         <div class="u-max-width u-p-t-90 u-p-b-20" style ="background:##E5E5E5">
             <div class="u-min-width supplierAdminItem4">
                   <div class="supplierAdminItem4Title">覆盖主流海外电商平台场景需求</div>
                   <div class="supplierAdminItem4Title2 u-m-t-20 u-m-b-50">支持各类海外电商平台、分销商一键接入百万货源</div>
                   <ul class="supplierAdminItem4-ul u-flex u-row-between">
                        <li>
                            <div class="supplierAdminItem4img">
                                <img src="../../../assets/NewImg/supplier1.png">
                            </div>
                            <div class="u-flex-1 u-p-l-40 u-p-r-40">
                                <div class="ul-li-titlt1 u-m-t-20">海外传统商城货源采购</div>
                                <div class="ul-li-titlt2 u-m-t-20">传统连锁商城、购物APP等业务覆盖全球多个国家的跨境商城卖家一键采购...</div>
                            </div>
                            <img class="u-m-l-40" style="width:120px;margin-bottom:20px;float:left" src="../../../assets/logo2.png">
                        </li>
                         <li>
                            <div class="supplierAdminItem4img">
                                <img  src="../../../assets/NewImg/supplier2.png">
                            </div>
                            <div class="u-flex-1 u-p-l-40 u-p-r-40">
                                <div class="ul-li-titlt1  u-m-t-20">海外跨境电商平台货源采购</div>
                                <div class="ul-li-titlt2 u-m-t-20">Ozon、Lazada、Shopee等各类新兴跨境电商平台卖家一件采购</div>
                            </div>
                            <img class="u-m-l-40" style="width:120px;margin-bottom:20px;float:left" src="../../../assets/logo2.png">
                        </li>
                        <li>
                            <div class="supplierAdminItem4img">
                                <img  src="../../../assets/NewImg/supplier3.png">
                            </div>
                             <div class="u-flex-1 u-p-l-40 u-p-r-40">
                                <div class="ul-li-titlt1  u-m-t-20">海外短视频店铺货源采购</div>
                                <div class="ul-li-titlt2 u-m-t-20">海外版抖音Tik tok，拥有15亿+全球用户的短视频电商平台，Tik tok小店卖家一键采购卖全球</div>
                            </div>
                            <img class="u-m-l-40" style="width:120px;margin-bottom:20px;float:left" src="../../../assets/logo2.png">
                        </li>
                         <li>
                             <div class="supplierAdminItem4img">
                                <img  src="../../../assets/NewImg/supplier4.png">
                            </div>
                             <div class="u-flex-1 u-p-l-40 u-p-r-40">
                                <div class="ul-li-titlt1  u-m-t-20">海外独立站商城货源采购</div>
                                <div class="ul-li-titlt2 u-m-t-20">各类移动H5、电脑端网页商城系统，10W+跨境创业者一键采购，产品轻松卖全球</div>
                            </div>
                            <img class="u-m-l-40" style="width:120px;margin-bottom:20px;float:left" src="../../../assets/logo2.png">
                        </li>
                   </ul>
                  
             </div>
        </div>
         <div class="u-max-width u-m-t-140 u-p-t-140 u-p-b-90 supplierAdminItem6bg">
            <div class="u-min-width supplierAdminItem6">
                <p class="supplierAdminItem6Title u-m-b-100">ONEBO全品类供应链核心优势</p>
                <div class="supplierAdminItem6View u-flex u-row-between">
                    <div class="supplierAdminItem6-item">
                         <div class="supplierAdminItem6-item-title" style="background: #FD2346;">多</div>
                         <div class="supplierAdminItem6-item-title2 u-m-t-20">20+货源类目、100万+SKU商品满足各行业需求</div>
                    </div>
                     <div class="supplierAdminItem6-item">
                         <div class="supplierAdminItem6-item-title" style="background: #FD681C;">正</div>
                         <div class="supplierAdminItem6-item-title2 u-m-t-20">整合10万+一手厂商渠道货源，正品保障假一罚十</div>
                    </div>
                     <div class="supplierAdminItem6-item">
                         <div class="supplierAdminItem6-item-title" style="background: #155FCA;">好</div>
                         <div class="supplierAdminItem6-item-title2 u-m-t-20">出厂低价、持续上新数100万+货源极具性价比</div>
                    </div>
                     <div class="supplierAdminItem6-item">
                         <div class="supplierAdminItem6-item-title" style="background: #FD681C;">快</div>
                         <div class="supplierAdminItem6-item-title2 u-m-t-20">一键上架、一件刊登、一件代发 7*16小时售后服务</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="u-max-width u-p-t-160 u-p-b-40 supplierAdminItem5bg">
             <div class="u-min-width u-p-t-40 u-p-b-20 u-p-b-40 supplierAdminItem5">
                   <div class="supplierAdminItem5Title">ONEBO全类目供应链入驻</div>
                    <div class="supplierAdminItem5Title2 u-m-t-20 u-m-b-30">20+商品类目、100万+SKU</div>
                   <ul class="supplierAdminItem5-ul u-flex u-row-around">
                        <li>
                            <div class="ul-li-img" ></div>
                            <div class="ul-li-titlt1 u-m-t-10">母婴</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-360px 0px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">3C数码</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-720px  0px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">宠物用品</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-1080px 0px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">户外和运动</div>
                        </li>
                   </ul>
                     <ul class="supplierAdminItem5-ul u-flex u-row-around u-m-t-20">
                        <li>
                            <div class="ul-li-img" style="background-position:0px -240px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">家居百货</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-360px -240px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">美容与健康</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-720px  -240px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">珠宝首饰</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-1080px -240px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">女装</div>
                        </li>
                   </ul>
                     <ul class="supplierAdminItem5-ul u-flex u-row-around u-m-t-20">
                         <li>
                            <div class="ul-li-img" style="background-position:0px -480px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">男装</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-360px -480px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">内衣和睡衣</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-720px  -480px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">箱包</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-1080px -480px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">鞋类</div>
                        </li>
                   </ul>
                     <ul class="supplierAdminItem5-ul u-flex u-row-around u-m-t-20">
                          <li>
                            <div class="ul-li-img" style="background-position:0px -720px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">汽摩配</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-360px -720px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">小家电</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-720px  -720px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">园林园艺</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-1080px -720px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">照明和装饰</div>
                        </li>
                   </ul>
                    <ul class="supplierAdminItem5-ul u-flex u-row-around u-m-t-20">
                          <li>
                            <div class="ul-li-img" style="background-position:0px -960px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">玩具和无人机</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-360px -960px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">美发</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-720px  -960px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">家纺</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-1080px -960px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">成人与健康</div>
                        </li>
                   </ul>
             </div>
        </div>
       
        <div class="u-max-width u-p-t-100 u-p-b-100 supplierAdminItem8bg">
              <div class="u-min-width supplierAdminItem8">
                <div class="supplierAdminItem8Title  u-m-b-100">ONEBO-助你成为电商大卖家</div>
                <ul class="u-flex u-row-between  supplierAdminItem8_ul1">
                    <li>
                        <div class="ul-li-imgbg">
                            <div class="ul-li-img"></div>
                        </div>
                        <div class="ul-li-title1 u-m-t-40">拥有营业资质</div>
                    </li>
                     <li>
                        <div class="ul-li-imgbg">
                             <div class="ul-li-img" style="background-position: -180px;"></div>
                        </div>
                        <div class="ul-li-title1 u-m-t-40">一手工厂货源</div>
                    </li>
                     <li>
                        <div class="ul-li-imgbg">
                            <div class="ul-li-img" style="background-position: -355px ;"></div>
                        </div>
                        <div class="ul-li-title1 u-m-t-40">要有现货，不接收清仓产品</div>
                    </li>
                     <li>
                        <div class="ul-li-imgbg">
                             <div class="ul-li-img" style="background-position: -532px;"></div>
                        </div>
                        <div class="ul-li-title1 u-m-t-40">最好产品本身有特色</div>
                    </li>
                     <li>
                        <div class="ul-li-imgbg">
                             <div class="ul-li-img" style="background-position: -708px ;"></div>
                        </div>
                        <div class="ul-li-title1 u-m-t-40">接受48小时内发货</div>
                    </li>
                </ul>
              
              </div>
        </div>
        <div class="supplierAdminItem9View u-max-width u-p-t-140 u-p-b-60" style ="background:#FFF">
              <div class="u-min-width supplierAdminItem9">
                <div class="supplierAdminItem9Title u-m-b-60">供应链入驻流程</div>
                <ul class="u-flex u-row-between  supplierAdminItem9_ul1">
                    <li>
                        <div class="ul-li-img">
                            <img src="../../../assets/images/newImg/line1.png">
                            <span>1</span>
                            <div class="linkView">
                                <div class="link"></div>
                                <div class="link-rudio"></div>
                            </div>
                        </div>
                        <div class="ul-li-title1 u-m-t-20">填写表单</div>
                    </li>
                     <li>
                         <div class="ul-li-img">
                            <img src="../../../assets/images/newImg/line2.png">
                            <span>2</span>
                             <div class="linkView">
                                <div class="link"></div>
                                <div class="link-rudio"></div>
                            </div>
                        </div>
                        <div class="ul-li-title1 u-m-t-20">ONEBO联系</div>
                    </li>
                     <li>
                         <div class="ul-li-img">
                            <img src="../../../assets/images/newImg/line3.png">
                            <span>3</span>
                             <div class="linkView">
                                <div class="link"></div>
                                <div class="link-rudio"></div>
                            </div>
                        </div>
                        <div class="ul-li-title1 u-m-t-20">审核通过</div>
                    </li>
                     <li>
                         <div class="ul-li-img">
                            <img src="../../../assets/images/newImg/line4.png">
                            <span>4</span>
                             <div class="linkView">
                                <div class="link"></div>
                                <div class="link-rudio"></div>
                            </div>
                        </div>
                        <div class="ul-li-title1 u-m-t-20">商户上品</div>
                    </li>
                     <li>
                         <div class="ul-li-img">
                            <img src="../../../assets/images/newImg/line5.png">
                            <span>5</span>
                             <div class="linkView">
                                <div class="link"></div>
                                <div class="link-rudio"></div>
                            </div>
                        </div>
                        <div class="ul-li-title1 u-m-t-20">ONEBO审品</div>
                    </li>
                    <li>
                         <div class="ul-li-img">
                            <img src="../../../assets/images/newImg/line6.png">
                            <span>6</span>
                             <div class="linkView">
                                <div class="link"></div>
                                <div class="link-rudio"></div>
                            </div>
                        </div>
                        <div class="ul-li-title1 u-m-t-20">审品通过</div>
                    </li>
                    <li>
                         <div class="ul-li-img">
                            <img src="../../../assets/images/newImg/line7.png">
                            <span>7</span>
                        </div>
                        <div class="ul-li-title1 u-m-t-20">分销商卖货</div>
                    </li>
                    
                </ul>
                <div class="supplierAdminItem9_ul2">
                     <img style="width:100%" src="../../../assets/NewImg/liucheng8.png">
                </div>
                <div class="goMoreterrace" @click="geturl('/SupplierAdminform')">立即入驻</div>
              </div>
        </div>
        <myNewFoot :show="false"></myNewFoot>
    </div>
</template>
<script>
import myNewMenu from "@/components/newcomponents/myNewMenu"
import myNewFoot from "@/components/newcomponents/myNewFoot"
export default {
    name:'new_supplierAdmin',
    data(){
        return {

        }
    },
    components:{
        myNewMenu,
        myNewFoot
    },
    methods:{
        geturl(url){
            this.$router.push(
               {
                  path:url
               }
            )
        }
    }
    
}
</script>
<style lang="scss" scoped>
 .new_supplierAdmin{
    font-family: PingFang SC-Regular, PingFang SC;

    .supplierAdminbanner{
         background: url("../../../assets/orporateitem.png");
         background-size: 100% 110%;
         height: 900px;
         position: relative;
         .supplier-bannnertext{
           
            position: absolute;
            top:220px;
            left: 250px;
            text-align: left;
            .supplier-bannnertext1{
                font-size: 75px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFF;
            }
            .supplier-bannnertext2{
               margin-top: 40px;
               font-size: 24px;
               font-family: PingFang SC-Regular, PingFang SC;
               font-weight: 400;
               color: #ffffffab;
            }
            .supplier-bannnertext3{
               margin-top: 40px;
               font-size: 18px;
               font-family: PingFang SC-Regular, PingFang SC;
               font-weight: 400;
               color: #ffffffab;
            }
            .supplier-bannnerbtn{
                display: flex;
                margin-top: 100px;
                & div{
                    width: 100px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 13px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    cursor: pointer;
                }
                .bannnerbtn{
                    background: linear-gradient(90deg, #FC6B1D 0%, #F98F43 100%);
                    border: 1px solid #FD681C;
                    color: #fff;
                }
                .bannnerbtn2{
                    margin-left: 20px;
                    border: 1px solid #FD681C;
                    color: #FD681C

                }
                .bannnerbtn2-size{
                    width: 180px;
                }
                .bannnerbtn2-a{
                    color: rgb(253, 104, 28);
                    text-decoration: none;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
         }
         .supplier-bannnerlogo{
            position: absolute;
            top:30px;
            right: 100px;
         }
         .supplier-bannnerfoot{
             position: absolute;
             bottom: 0;
             left: 0;
             height: 80px;
             width: 100%;
             background: #00000078;
             .bannnerfootItem{
                   flex: 1;
                   height: 100%;
                   display: flex;
                   justify-content: center;
                   align-items: center;
                   & span:nth-child(1){
                        font-size: 17px;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                   }
                   & span:nth-child(2){
                        font-size: 17px;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFF;
                   }
             }
         }
    }

    .supplierAdminItem3{
        .supplierAdminItem3Title{
            font-size: 36px;
            text-align: center;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 400;
            color: #000000;
        }
        .supplierAdminItem3Title2{
            font-size: 16px;
            text-align: center;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }
        .videoView{
            width:1420px;
            height:500px;
        }
        
    }
     .supplierAdminItem4{
        .supplierAdminItem4Title{
            font-size: 36px;
            text-align: center;
            font-weight: 400;
            color: #000000;
        }
        .supplierAdminItem4Title2{
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            text-align: center;
        }
        .supplierAdminItem4-ul{
            li{
               width: 337px;
                height: 550px;
                background:#FFF ;
                box-shadow: 0px 3px 21px 1px rgba(56,89,197,0.03);
                border-radius: 8px 8px 8px 8px;
                display: flex;
                justify-content:center;
                align-items: self-start;
                flex-direction: column;
                overflow: hidden;
                cursor: pointer;
                .supplierAdminItem4img{
                      width: 337px;
                      height: 337px;
                      overflow: hidden;
                    & img{
                        width: 337px;
                        height: 337px;
                    }
                }
                .ul-li-titlt1{
                    font-size: 21px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #010101;
                    text-align: left;
                }
                .ul-li-titlt2{
                    font-size: 15px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                    text-align: left;
                   
                }
                &:hover{
                     .supplierAdminItem4img{
                        & img{
                            transform: scale(1.4);
                        }
                }
                }
            }
        }
    }
    .supplierAdminItem5bg{
        background: #FFF;
        .supplierAdminItem5{
        .supplierAdminItem5Title{
           font-size: 36px;
           text-align: center;
           font-family: PingFang SC-Semibold, PingFang SC;
           font-weight: 400;
           color: #000000;
        }
        .supplierAdminItem5Title2{
            font-size: 16px;
             text-align: center;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }
        
        .supplierAdminItem5-ul{
            li{
                width: 337px;
                display: flex;
                justify-content:flex-start;
                align-items: center;
                flex-direction: column;
                .ul-li-img{
                    width: 337px;
                    height: 170px;
                    background: url("../../../assets/images/newImg/supplier6.png");
                }
                .ul-li-titlt1{
                    font-size: 16px;
                    font-weight: 400;
                    color: #37312D;
                }
                .ul-li-titlt2{
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #888888;
                    text-align: center;
                }
            }
        }
    }
    }
     .supplierAdminItem6bg{
        background: url('../../../assets/images/newImg/supplier5.png');
        background-size: 100% 100%;
        .supplierAdminItem6{
             .supplierAdminItem6Title{
               font-size: 36px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 400;
                color: #FFF;
                text-align: center;
                text-decoration: solid 2px #FD681C;
             }
             .supplierAdminItem6-item{
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                padding: 0 50px;
                .supplierAdminItem6-item-title{
                    width: 60px;
                    height: 60px;
                    line-height: 60px;
                    text-align: center;
                    background: #FD681C;
                    border-radius: 6px 6px 6px 6px;
                    opacity: 1;
                    font-size: 40px;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                }
                .supplierAdminItem6-item-title2{
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    text-align: center;
                }
             }
        }
    }

    .supplierAdminItem8bg{
       background: #f7f7f7;
        .supplierAdminItem8{
            .supplierAdminItem8Title{
                font-size: 36px ;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 400;
                color: #000;
                text-align: center;
            }
            .supplierAdminItem8_ul1{
                li{
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                margin-right: 70px;
                &:last-child{
                    margin-right: 0px;
                }
                .ul-li-imgbg{
                    width: 162px;
                    height: 162px;
                    border-radius: 50%;
                    background: #f7f2ed;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                     .ul-li-img{
                        width: 120px;
                        height: 108px;
                        background: url("../../../assets/images/newImg/indexImg1.png");
                        
                    }
                }
                .ul-li-title1{
                    font-size: 16px;
                    font-weight: 400;
                    color: #000;
                }
                .ul-li-title2{
                    font-size: 14px;
                    font-weight: 400;
                    color: #000;
                    height: 55px;
                }
                .ul-li-title3{
                    font-size: 16px;
                    font-weight: 400;
                    color: #FD681C;
                    cursor: pointer;
                }
                }
            }
        
            .goMoreterrace{
                width: 192px;
                height: 38px;
                line-height: 38px;
                text-align: center;
                margin: 30px auto 20px;
                border-radius: 0px 0px 0px 0px;
                opacity: 1;
                border: 1px solid #FD681C;
                font-size: 14px;
                font-weight: 400;
                color: #FD681C;
                cursor: pointer;
            }
        }
    }
    
   
    .supplierAdminItem9{
        .supplierAdminItem9Title{
            font-size: 28px !important;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 400;
            color: #000000;
            text-align: center;
        }
        .supplierAdminItem9_ul1{
            li{
               flex: 1;
               display: flex;
               justify-content: center;
               align-items: center;
               flex-direction: column;
               margin-right: 70px;
               &:last-child{
                 margin-right: 0px;
               }
               .ul-li-img{
                  width: 64px;
                  height: 58px;
                  position: relative;
                  & img{
                     width: 64px;
                     height: 58px;
                  }
                  & span{
                    display: inline-block;
                    width: 64px;
                    height: 58px;
                    line-height: 58px;
                    text-align: center;
                    font-size: 20px;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #252B3A;
                    position: absolute;
                    top:0;
                    left: 0;

                  }
                  .linkView{
                    display: flex;
                    align-items: center;
                    position: absolute;
                    top: 25px;
                    right: -115px;
                    .link{
                        width: 70px;
                        border-bottom: 2px dotted #A0A2A8;
                    }
                    .link-rudio{
                        margin-left: 2px;
                        width: 6px;
                        height: 6px;
                        background: #A0A2A8;
                        border-radius: 50%;
                    }
                  }
               }
               .ul-li-title1{
                  font-size: 14px;
                  font-family: PingFang SC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #000000;
               }
              
            }
        }
        .supplierAdminItem9_ul2{
            display: none;
        }
        .goMoreterrace{
            width: 192px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            margin: 30px auto 20px;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            border: 1px solid #FD681C;
            font-size: 14px;
            font-weight: 400;
            color: #FD681C;
            cursor: pointer;
        }
    }
    
 }
</style>
<style lang="scss" scoped>
@media  screen and (max-width:760px) {
 .new_supplierAdmin{
    font-family: PingFang SC-Regular, PingFang SC;

    .supplierAdminbanner{
         height: 400px;
         .supplier-bannnertext{
            width: 78%;
            top:70px !important;
            left:50% !important;
            transform: translateX(-50%);
            .supplier-bannnertext1{
                font-size: 24px !important;
                font-weight: bold;
              
            }
            .supplier-bannnertext2{
               margin-top: 10px;
               font-size: 14px;
               padding-right: 10px;
            }
            .supplier-bannnertext3{
               margin-top: 10px !important;
               font-size: 14px;
               padding-right: 10px;
               color: #ffffffab;
            }
            .supplier-bannnerbtn{
                display: flex;
                margin-top: 20px;
                & div{
                    width: 100px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    font-size: 13px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    cursor: pointer;
                }
                .bannnerbtn{
                    background: linear-gradient(90deg, #FC6B1D 0%, #F98F43 100%);
                    border: 1px solid #FD681C;
                    color: #fff;
                }
                .bannnerbtn2{
                    margin-left: 20px;
                    border: 1px solid #FD681C;
                    color: #FD681C
                }
                .bannnerbtn2-size1{
                    width: 120px !important;
                }
                .bannnerbtn2-size{
                    width: 230px;
                }
                bannnerbtn2-a{
                    display: flex;
                    width: 180px
                }
            }
         }
         .supplier-bannnerlogo{
            position: absolute;
            top:30px;
            right: 100px;
         }
         .supplier-bannnerfoot{
             position: absolute;
             bottom: 0px;
             left: 0px;
             height: 80px;
             width: 100%;
             background: #00000078;
             .supplier-bannnerfootView{
                flex-wrap: wrap;
                 .bannnerfootItem{
                    flex: none !important;
                   width: 50% !important;
                   height: 50% !important;
                   display: flex;
                   justify-content: center;
                   align-items: center;
                   & span:nth-child(1){
                        font-size: 17px;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                   }
                   & span:nth-child(2){
                        font-size: 17px;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFF;
                   }
             }
             }
            
         }
    }

    .supplierAdminItem3{
        .supplierAdminItem3Title{
            font-size: 28px;
           
        }
        .supplierAdminItem3Title2{
            font-size: 16px;
            text-align: center;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }
         .videoView{
            width:100% !important;
            height:auto !important;
        }
    }
     .supplierAdminItem4{
        .supplierAdminItem4Title{
            font-size: 28px;
        }
        .supplierAdminItem4-ul{
            flex-direction: column;
            li{
                width: 337px;
                height: 550px;
                background:#FFF ;
                box-shadow: 0px 3px 21px 1px rgba(56,89,197,0.03);
                border-radius: 8px 8px 8px 8px;
                display: flex;
                justify-content:center;
                align-items: self-start;
                flex-direction: column;
                overflow: hidden;
                cursor: pointer;
                margin-bottom: 20px !important;
                .supplierAdminItem4img{
                      width: 337px;
                      height: 337px;
                      overflow: hidden;
                    & img{
                        width: 337px;
                        height: 337px;
                    }
                }
                .ul-li-titlt1{
                    font-size: 21px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #010101;
                    text-align: left;
                }
                .ul-li-titlt2{
                    font-size: 15px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                    text-align: left;
                   
                }
                &:hover{
                     .supplierAdminItem4img{
                        & img{
                            transform: scale(1.4);
                        }
                }
                }
            }
        }
    }
    .supplierAdminItem5bg{
        background: #FFF;
        padding-top: 30px !important;
        .supplierAdminItem5{
        .supplierAdminItem5Title{
           font-size: 28px;
        }
        .supplierAdminItem5Title2{
            font-size: 16px;
             text-align: center;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }
        
        .supplierAdminItem5-ul{
               flex-wrap: wrap;
            li{
               width: 45%;
                display: flex;
                justify-content:flex-start;
                align-items: center;
                flex-direction: column;
                .ul-li-img{
                    width: 100%;
                    height: 100px;
                    background: url("../../../assets/images/newImg/supplier6.png");
                }
                .ul-li-titlt1{
                    font-size: 16px;
                    font-weight: 400;
                    color: #37312D;
                }
                .ul-li-titlt2{
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #888888;
                    text-align: center;
                }
            }
        }
    }
    }
     .supplierAdminItem6bg{
        background: url('../../../assets/images/newImg/supplier5.png');
        background-size: 230% 100%;
        margin-top: 10px !important;
        padding-top:40px !important;
        .supplierAdminItem6{
             .supplierAdminItem6Title{
               font-size: 28px !important;
             }
             .supplierAdminItem6View{
                flex-wrap: wrap;
                    .supplierAdminItem6-item{
                        width: 49% !important;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                        padding: 0 !important;
                        margin-bottom: 20px !important;
                        .supplierAdminItem6-item-title2{
                           
                            padding: 0 30px;
                        }
                    }
             }

        }
    }
    
     .supplierAdminItem8bg{
       background: #f7f7f7;
       padding-top:50px ;
       padding-bottom: 20px ;
        .supplierAdminItem8{
            .supplierAdminItem8Title{
                font-size: 28px ;
                margin-bottom: 20px;
            }
            .supplierAdminItem8_ul1{
                flex-wrap: wrap;
                flex-direction: column;
                li{
                  margin-right: 0 !important;
                  margin-bottom: 40px !important;
                .ul-li-imgbg{
                    width: 162px;
                    height: 162px;
                    border-radius: 50%;
                    background: #f7f2ed;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                     .ul-li-img{
                        width: 120px;
                        height: 108px;
                        background: url("../../../assets/images/newImg/indexImg1.png");
                        
                    }
                }
                .ul-li-title1{
                   margin-top: 10px !important;
                }
                .ul-li-title2{
                    font-size: 14px;
                    font-weight: 400;
                    color: #000;
                    height: 55px;
                }
                .ul-li-title3{
                    font-size: 16px;
                    font-weight: 400;
                    color: #FD681C;
                    cursor: pointer;
                }
                }
            }
        
            .goMoreterrace{
                width: 192px;
                height: 38px;
                line-height: 38px;
                text-align: center;
                margin: 30px auto 20px;
                border-radius: 0px 0px 0px 0px;
                opacity: 1;
                border: 1px solid #FD681C;
                font-size: 14px;
                font-weight: 400;
                color: #FD681C;
                cursor: pointer;
            }
        }
    }
   
   .supplierAdminItem9View{
        padding-top: 30px !important;
        .supplierAdminItem9{
        .supplierAdminItem9Title{
            font-size: 36px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 400;
            color: #000000;
            text-align: center;
        }
        .supplierAdminItem9_ul1{
           display: none;
        }
        .supplierAdminItem9_ul2{
            display: block;
        }
        .goMoreterrace{
            width: 192px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            margin: 30px auto 20px;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            border: 1px solid #FD681C;
            font-size: 14px;
            font-weight: 400;
            color: #FD681C;
            cursor: pointer;
        }
    }
    
   }
   
 }
}
</style>